export default {
  order_again: 'Order again',
  error_messages: {
    product_does_not_exist: 'The product is no longer available',
  },
  success_messages: {
    product_added_to_card: 'Product added to card',
  },
};
